import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import SweetAlert from 'react-bootstrap-sweetalert';
import api from '../../../services/api';
import { Container, Table } from './styles';

import Button from '../../../components/Button';
import Input from '../../../components/Input';
import Loading from '../../../components/Loading';

export default class UpdateFollowers extends Component {
  state = {
    alert: {},
    loading: true,
    showAlert: false,
    tickets: [],
  };

  componentDidMount() {
    this.loadTickets();
  }

  loadTickets = async () => {
    try {
      const { data } = await api.get('admin/tickets', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
        params: {
          kind: 'update_followers',
          results: 0,
          status: 'opened',
        },
      });

      const { tickets } = data;

      this.setState({ tickets, loading: false });

      tickets.forEach((ticket) => {
        this.setState({
          [`followers-${ticket.promoter.id}`]: ticket.promoter.followers,
          [`engagement-${ticket.promoter.id}`]: ticket.promoter.engagement,
        });
      });
    } catch (err) {
      this.setState({ tickets: [] });
    }
  };

  updateTicket = async (id, promoterId) => {
    const formData = new FormData();
    formData.append('engagement', this.state[`engagement-${promoterId}`]);
    formData.append('followers', this.state[`followers-${promoterId}`]);

    try {
      await api.put(`admin/promoters/${promoterId}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
      });
      await api.put(
        `admin/tickets/${id}`,
        {
          ticket: { status: 'closed' },
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
          },
        },
      );

      const { tickets } = this.state;

      this.setState(
        {
          alert: {
            title: 'Sucesso',
            type: 'success',
            messages: ['Divulgador atualizado com sucesso!'],
            onConfirm: () => this.closeAlert(),
          },
          tickets: tickets.filter(ticket => ticket.id !== id),
        },
        () => {
          this.openAlert();
        },
      );
    } catch (err) {
      const messages = ['Não foi possível aprovar o ticket. Por favor, atualize a página.'];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  deleteTicket = async (id) => {
    const { tickets } = this.state;
    try {
      await api.delete(`admin/tickets/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
      });
      this.setState({ tickets: tickets.filter(ticket => ticket.id !== id) });
    } catch (err) {
      const messages = err.response
        ? err.response.data.errors
        : ['Não foi possível aprovar o ticket. Por favor, atualize a página.'];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      loading,
      tickets,
      showAlert,
    } = this.state;

    return (
      <Fragment>
        {loading ? (
          <Loading />
        ) : (
          <Container>
            <h1 className="page-title">Solicitações para atualizar seguidores {tickets && ` (${tickets.length})`}</h1>
            <div className="box">
              <div className="row">
                <div className="col-12">
                  {tickets.length > 0 ? (
                    <div className="table-wrapper">
                      <Table className="table">
                        <thead>
                          <tr>
                            <th>Foto</th>
                            <th>Nome</th>
                            <th>Instagram</th>
                            <th>Nº de seguidores</th>
                            <th>Engajamento</th>
                            <th>Atualizar</th>
                            <th>Deletar solicitação</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tickets.map(ticket => (
                            <tr key={ticket.promoter.id}>
                              <td>
                                <div
                                  className="profile-image"
                                  style={
                                    ticket.promoter.avatar.url && {
                                      backgroundImage: `url(${ticket.promoter.avatar.url})`,
                                    }
                                  }
                                />
                              </td>
                              <td>{ticket.promoter.name}</td>
                              <td>
                                <a
                                  href={`http://instagram.com/${ticket.promoter.instagram_username}`}
                                  target="blank"
                                >
                                  @{ticket.promoter.instagram_username}
                                </a>
                              </td>
                              <td>
                                <Input
                                  name={`followers-${ticket.promoter.id}`}
                                  value={this.state[`followers-${ticket.promoter.id}`]}
                                  onChange={this.handleChange}
                                />
                              </td>
                              <td>
                                <Input
                                  name={`engagement-${ticket.promoter.id}`}
                                  value={this.state[`engagement-${ticket.promoter.id}`]}
                                  onChange={this.handleChange}
                                />
                              </td>
                              <td>
                                <Button
                                  onClick={() => this.updateTicket(ticket.id, ticket.promoter.id)}
                                  className="btn-success btn-small"
                                >
                                  <FontAwesomeIcon icon={faCheck} />
                                </Button>
                              </td>
                              <td>
                                <Button
                                  onClick={() => this.deleteTicket(ticket.id)}
                                  className="btn-outline-secondary btn-small"
                                >
                                  <FontAwesomeIcon icon={faTimes} />
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <h5 className="text-center">Não existem solicitações pendentes.</h5>
                  )}
                </div>
              </div>
            </div>
            {showAlert && (
              <SweetAlert
                type={type}
                confirmBtnText={confirmBtnText}
                confirmBtnBsStyle={confirmBtnBsStyle}
                showCancel={showCancel}
                cancelBtnText={cancelBtnText}
                cancelBtnBsStyle={cancelBtnBsStyle}
                title={title}
                onConfirm={onConfirm}
                onCancel={this.closeAlert}
              >
                <ul>
                  {messages.map(msg => (
                    <li key={msg}>{msg}</li>
                  ))}
                </ul>
              </SweetAlert>
            )}
          </Container>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/pages/UpdateFollowers/index.js